/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_user">;
    readonly " $refType": "PdpRespIconBubbles_user";
};
export type PdpRespIconBubbles_user$data = PdpRespIconBubbles_user;
export type PdpRespIconBubbles_user$key = {
    readonly " $data"?: PdpRespIconBubbles_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespIconBubbles_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_user",
      "args": null
    }
  ]
};
(node as any).hash = 'b7a8dd895310a3ea7fad8ff60cbc97c3';
export default node;
